import React from 'react';
import { NavLink } from 'react-router-dom';
import { C, NAV } from '../tokens';
import Icon from './Icon';

export default function Sidebar({ collapsed, mobileOpen }) {
  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}${mobileOpen ? ' mobile-open' : ''}`}>
      {/* Brand */}
      <div
        style={{
          padding: collapsed ? '22px 0' : '22px 24px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          justifyContent: collapsed ? 'center' : 'flex-start',
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: C.primary,
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
          }}
        >
          <Icon name="bolt" size={22} style={{ color: '#fff' }} />
        </div>
        {!collapsed && (
          <h1
            style={{
              fontSize: 17,
              fontWeight: 800,
              letterSpacing: '-.02em',
              whiteSpace: 'nowrap',
              textTransform: 'uppercase',
            }}
          >
            Nieramind<span style={{ color: C.primary }}>.AI</span>
          </h1>
        )}
      </div>

      {/* Nav links */}
      <nav
        style={{
          flex: 1,
          padding: collapsed ? '8px 10px' : '8px 16px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {NAV.map((n) => (
          <NavLink
            key={n.key}
            to={n.path}
            className={({ isActive }) =>
              `nav-btn${isActive ? ' active' : ''}${collapsed ? ' collapsed-btn' : ''}`
            }
          >
            <Icon name={n.icon} size={22} style={{ flexShrink: 0 }} />
            {!collapsed && (
              <span
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {n.label}
              </span>
            )}
            {n.badge && (
              <span
                style={{
                  position: collapsed ? 'absolute' : 'static',
                  top: collapsed ? 4 : undefined,
                  right: collapsed ? 6 : undefined,
                  marginLeft: collapsed ? 0 : 'auto',
                  background: C.red,
                  color: '#fff',
                  fontSize: 10,
                  fontWeight: 700,
                  borderRadius: 99,
                  minWidth: 20,
                  height: 20,
                  display: 'grid',
                  placeItems: 'center',
                  padding: '0 6px',
                }}
              >
                {n.badge}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Bottom user */}
      <div
        style={{
          borderTop: `1px solid ${C.bdr}`,
          padding: collapsed ? '16px 0' : '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          justifyContent: collapsed ? 'center' : 'flex-start',
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${C.primary}, ${C.amber})`,
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
            color: '#fff',
            fontWeight: 700,
            fontSize: 14,
          }}
        >
          AR
        </div>
        {!collapsed && (
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.2, whiteSpace: 'nowrap' }}>
              Alex Rivera
            </div>
            <div style={{ fontSize: 11, color: C.t3, whiteSpace: 'nowrap' }}>Ops Lead</div>
          </div>
        )}
      </div>
    </aside>
  );
}
